import { render } from "./ProfilePicture.vue?vue&type=template&id=49d66b74&scoped=true"
import script from "./ProfilePicture.vue?vue&type=script&lang=js"
export * from "./ProfilePicture.vue?vue&type=script&lang=js"

import "./ProfilePicture.vue?vue&type=style&index=0&id=49d66b74&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49d66b74"]])

export default __exports__